import type { TFunction } from 'i18next'
import * as Yup from 'yup'
import { createCompanyNameValidationSchema } from '@dhl/inputs'
import type { Address } from '@dhl/input-address'

export const createReturnHubsValidationSchema = (t: TFunction, addressValidationSchema: Yup.Schema<Address>) => {
  return Yup.object()
    .shape({
      name: createCompanyNameValidationSchema(t).required(
        t('admin.returnHubPage.returnHubFormInputErrorMessage.companyIsRequired')
      ),
      address: addressValidationSchema,
    })
    .defined()
}
